import { render, staticRenderFns } from "./quest-input.vue?vue&type=template&id=c5f61478"
import script from "./quest-input.vue?vue&type=script&lang=js"
export * from "./quest-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports